// Module
var code = "<div class=\"hamburger__line\"></div> ";
// Exports
export default code;